/**
 * Entry point. Mounts <App/> inside an ErrorBoundary so a render error
 * anywhere in the tree surfaces a recoverable fallback instead of a blank
 * screen. Loads the Inter variable font from @fontsource-variable.
 */
import { initSentry, readSentryEnv } from "@/lib/sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import "./index.css";
import { ErrorBoundary } from "@/components/error-boundary";
import App from "./App";

// Init Sentry first so global error handlers exist before the React
// tree mounts and the first render happens. `initSentry` is a no-op
// when `VITE_SENTRY_DSN` is unset.
initSentry(readSentryEnv());

const container = document.getElementById("root");
if (!container) {
  throw new Error("puku-pcb: #root element missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary label="puku-pcb">
      <App />
    </ErrorBoundary>
  </StrictMode>
);
